import moment from 'moment'

export default function formatDate(date, time) {
  return (
    moment(date, 'YYYY-MM-DD').format('MMM D YYYY') + (time ? ', ' + time : '')
  )
}
